<template>
  <div class="promoted_setting">
    <el-form ref="ruleForm" :rules="rules" :model="ruleForm" class="unify-box" label-width="auto">
      <p class="title">晋级设置</p>
      <el-form-item label="是否启用自动晋级:" prop="enabled">
        <el-radio-group v-model="ruleForm.enabled" @input="radioValChange">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="过去" prop="intervalOfDay">
        <el-input v-model="ruleForm.intervalOfDay" placeholder="请输入" :disabled="isDisabled" />
        <span style="margin-left: 10px; color: #606266; font-weight: bold;">天内</span>
      </el-form-item>
      <el-form-item label="胜率超过（含）" prop="winRate">
        <el-input v-model="ruleForm.winRate" placeholder="请输入" :disabled="isDisabled" />
        <span style="margin-left: 10px; color: #606266; font-weight: bold;">%</span>
      </el-form-item>
      <el-form-item label="平均有效积分（含）" prop="validScore">
        <el-input v-model="ruleForm.validScore" placeholder="请输入" :disabled="isDisabled" />
        <span style="margin-left: 10px; color: #606266; font-weight: bold;">分</span>
      </el-form-item>
      <el-form-item label="有效比赛站次" prop="minMatchCount">
        <el-input v-model="ruleForm.minMatchCount" placeholder="请输入" :disabled="isDisabled" />
        <span style="margin-left: 10px; color: #606266; font-weight: bold;">站</span>
      </el-form-item>
      <el-form-item label="最多追溯比赛站数" prop="stationCountTrace">
        <el-input v-model="ruleForm.stationCountTrace" placeholder="请输入" :disabled="isDisabled" />
        <span style="margin-left: 10px; color: #606266; font-weight: bold;">站</span>
      </el-form-item>
      <el-form-item>
        <div class="btnWrap">
          <el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
          <el-button @click="resetForm('ruleForm')" :disabled="isDisabled">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    const numberReg = /^\+?[1-9]\d*$/
    const numberReg2 = /^(0|[1-9]\d*)(\.\d{1,2})?$/
    const ValidatorRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入'))
      } else if (!numberReg.test(value)) {
        callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    }
    const ValidatorRules2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入'))
      } else if (!numberReg2.test(value)) {
        callback(new Error('请输入正确数字'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        enabled: [{ required: true, message: '请选择是否启用自动晋级', trigger: 'blur' }],
        intervalOfDay: [{ required: true, validator: ValidatorRules, trigger: 'blur' }],
        minMatchCount: [{ required: true, validator: ValidatorRules, trigger: 'blur' }],
        stationCountTrace: [{ required: true, validator: ValidatorRules, trigger: 'blur' }],
        winRate: [{ required: true, validator: ValidatorRules2, trigger: 'blur' }],
        validScore: [{ required: true, validator: ValidatorRules2, trigger: 'blur' }]
      },
      ruleForm: {
        enabled: '',
        intervalOfDay: null,
        minMatchCount: null,
        stationCountTrace: null,
        winRate: null,
        validScore: null
      },
      isDisabled: false
    }
  },
  created () {
    this.getData()
  },
  methods: {
    // 获取每日扫描的会员晋级系统配置
    getData () {
      this.$http({
        url: this.$http.adornUrl('/sys/config/getAutoAdjustConfig'),
        method: 'get'
      }).then((data) => {
        if (data.code == 0) {
          let resData = data.data
          resData.intervalOfDay = Math.abs(resData.intervalOfDay)
          this.ruleForm = resData;
          if (resData.enabled == 0) this.isDisabled = true
        }
      })
    },
    save () {
      // let intervalOfDay = -this.ruleForm.intervalOfDay
      let data = this.$http.adornData({
        intervalOfDay: this.ruleForm.intervalOfDay,
        minMatchCount: this.ruleForm.minMatchCount,
        stationCountTrace: this.ruleForm.stationCountTrace,
        winRate: this.ruleForm.winRate,
        validScore: this.ruleForm.validScore,
        enabled: this.ruleForm.enabled
      })
      this.$http({
        url: this.$http.adornUrl('/sys/config/updateAutoAdjustConfig'),
        method: 'post',
        data
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message.success('修改成功')
        }
      })
    },
    radioValChange (val) {
      this.isDisabled = !(val == 1)
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save()
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang="scss">
.promoted_setting {
  width: 90%;
  margin: 40px auto 0;

  .unify-box {
    margin: 40px auto 0;
    border: 1px solid rgb(187, 187, 187);
    border-radius: 10px;
    padding: 30px 40px 20px;
    position: relative;

    .el-input {
      width: 100px;
    }

    .el-form-item__label-wrap,
    .el-form-item__content {
      margin-left: 0 !important;
    }

    .el-form-item__label {
      font-size: 14px;
      font-weight: bold;
      color: #606266;
    }

    .btnWrap {
      display: flex;
      justify-content: center;

      .el-button {
        width: 118px;
      }

      .el-button--primary {
        background: rgb(129, 179, 55);
        color: #fff;
        margin-right: 30px;
      }
    }

    .title {
      width: 150px;
      font-size: 14px;
      text-align: center;
      background: #fff;
      position: absolute;
      top: -11px;
      left: 50px;
      letter-spacing: 1px;
      margin: 0; //去除默认属性影响
    }

    .gap {
      font-weight: bold;
      color: rgb(16, 16, 16);
      margin: 0 10px;
    }

    .number {
      width: 300px;
    }

    .label {
      font-size: 14px;
      font-weight: bold;
      color: #606266;
      margin-right: 12px;
    }

    .pay-inp {
      width: 200px;
      margin-right: 5px;
    }

    .gap-top {
      margin-top: 20px;
    }
  }
}
</style>
